/// <reference path="Main.js" />
/// <reference path="Enumeration-vsdoc.js" />
/// <reference path="Strings-vsdoc.js" />

window.JJK = window.JJK || {};

JJK.TextBoxHelper = function () {};

JJK.TextBoxHelper.prototype = {
	LabelInTextbox: function (textbox, span) {
		$(textbox).prop('textboxhelper', this);
		$(textbox).prop('labelspan', span);

		const handler = this.MakeLabelHandler(textbox, span);
		$(textbox).on('focus blur change paste input keypress', handler);

		handler();
		JJK.AsyncMethod(this, handler, 250);
	},

	MakeLabelHandler: function (textbox, span) {
		return function () {
			const tb = $(textbox);
			if (!tb.length) {
				return;
			}

			function checkAutoFill() {
				if (!/AppleWebKit/.test(navigator.userAgent) || navigator.userAgent.match(/Windows Phone/i)) {
					return false;
				}
				try {
					return $(`${textbox}:-webkit-autofill`).length > 0;
				} catch (e) {
					return false;
				}
			}
			const state = tb.is(':focus') || tb.val() !== '' || checkAutoFill() ? 'none' : 'inline-block';
			if ($(span).css('display') === state) {
				return;
			}
			$(span).css('display', state);
		};
	},

	CheckLabel: function (span, show) {
		if (show) {
			$(span).css('display', 'inline-block');
		} else {
			$(span).css('display', 'none');
		}
	},

	ToggleLabelVisibility: function (formId) {
		const textboxes = $(`#${formId} input[type='text'], input[type='password']`);
		const self = this;
		textboxes.each(function () {
			const id = $(this)[0].id;
			self.LabelInTextbox(`#${id}`, `#${id}Span`);
		});
	},

	ResetLabelVisibility: function (formId) {
		const textboxes = $(`#${formId} input[type='text'], input[type='password']`);
		const self = this;
		textboxes.each(function () {
			const id = $(this)[0].id;
			self.ResetLabelInTextbox($(this), `#${id}Span`);
		});
	},

	ResetLabelInTextbox: function (textbox, span) {
		if ($(textbox).val() === '') {
			$(span).css('display', 'inline-block');
		}
	},

	EnableControls: function (formId, enable) {
		const textboxes = $(`#${formId} input[type='text'], input[type='password']`);
		const self = this;
		textboxes.each(function () {
			self.EnableControl($(this), enable);
		});
	},

	EnableControl: function (control, enable) {
		if (enable === true) {
			$(control).removeAttr('disabled');
			return;
		}
		$(control).prop('disabled', 'disabled');
	},
};

jQuery.fn.extend({
	valEx: function (value) {
		if (value === undefined) {
			return this.val();
		}

		const result = this.val(value);
		const helper = this.prop('textboxhelper');
		if (helper) {
			helper.CheckLabel(this.prop('labelspan'), value === '');
		}
		return result;
	},
});
